import React from "react";
import {Link } from "react-router-dom";
import p3Img from "../../Assets/image/Digital-Standee-A-Shape-32-Inch.png";
import p6Img from"../../Assets/image/Digital-Standee-I-Shape-43-Inch-1300x1300.jpg";
import p4Img from "../../Assets/P6IMg.jpeg";
import p8Img from "../../Assets/Digital Standee50.jpeg";
import p9Img from "../../Assets/Untitled-design-3.png";
import standeeImg from "../../Assets/digital-standee.jpg";
import retailImg from "../../Assets/image/Digital-Standee-A-Shape-32-Inch.png";
import mallImg from "../../Assets/P6IMg.jpeg";
import eventImg from "../../Assets/image/Digital-Standee-I-Shape-43-Inch-1300x1300.jpg";

import { motion } from "framer-motion";
import { MonitorSmartphone, Wifi, Usb, LayoutTemplate, Volume2, Settings } from "lucide-react";

const features = [
  { title: "Full HD Display", icon: <MonitorSmartphone size={36} /> },
  { title: "WiFi & USB Connectivity", icon: <Wifi size={36} /> },
  { title: "Plug & Play Media Support", icon: <Usb size={36} /> },
  { title: "Slim & Modern Design", icon: <LayoutTemplate size={36} /> },
  { title: "Built-in Audio System", icon: <Volume2 size={36} /> },
  { title: "Easy Content Management", icon: <Settings size={36} /> },
];

const DigitalStandee = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="bg-[#F4F2F3] min-h-screen flex items-center px-6 lg:px-16 py-20">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

          <div>
            <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-8">
              <span className="text-blue-600">Beneicon</span> Digital-Standee <br />
              Display 
            </h1>

            <p className="text-gray-600 text-lg max-w-xl mb-10 leading-relaxed">
              Sleek and modern digital standees designed to elevate
              advertising, promotions, and customer engagement in retail
              stores, malls, events, and corporate environments.
            </p>
                      <a
  href="https://wa.me/+917065993135"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition shadow-lg inline-block"
>
  Request Your Demo
</a>
          </div>

          <div className="flex justify-center">
            <img
              src={standeeImg}
              alt="Digital Standee"
              className="w-full max-w-xl rounded-2xl shadow-2xl"
            />
          </div>

        </div>
      </section>

      {/* ================= FEATURES ================= */}
      <section className="bg-[#F4F2F3] py-20 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-10">

          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-500 p-12 flex flex-col items-center text-center"
            >
              <div className="mb-6 text-black">
                {feature.icon}
              </div>

              <h3 className="text-lg font-semibold text-gray-800">
                {feature.title}
              </h3>
            </motion.div>
          ))}

        </div>
      </section>

            <section className="bg-[#F4F2F3] py-20 px-6">
  <div className="max-w-7xl mx-auto">

    <h2 className="text-3xl font-bold mb-12">
      Related Products
    </h2>

    <div className="grid md:grid-cols-3 gap-10">

      <Link to="/DigitalStandeeA32" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img src={p3Img} alt="Outdoor LED Video Display P-3" className="h-64 w-full object-contain group-hover:scale-105 transition duration-500" />
        <div className="p-6 text-center font-semibold">
          Digital Standee A-Shape-32 Inch
        </div>
      </Link>

      <Link to="/DigitalStandeeA43" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img src={p4Img} alt="Outdoor LED Video Display P-4" className="h-64 w-full object-contain group-hover:scale-105 transition duration-500" />
        <div className="p-6 text-center font-semibold">
          Digital Standee A-Shape-43 Inch
        </div>
      </Link>

      <Link to="/DigitalStandeeI43" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img src={p6Img} alt="Outdoor LED P-6" className="h-64 w-full object-contain group-hover:scale-105 transition duration-500" />
        <div className="p-6 text-center font-semibold">
          Digital Standee I-Shape-43 Inch
        </div>
      </Link>
            <Link to="/DigitalStandeeI50" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img src={p8Img} alt="Outdoor LED P-6" className="h-64 w-full object-contain group-hover:scale-105 transition duration-500" />
        <div className="p-6 text-center font-semibold">
          Digital Standee I-Shape-50 Inch
        </div>
      </Link>
                  <Link to="/DigitalStandeeI55" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img src={p9Img} alt="Outdoor LED P-6" className="h-64 w-full object-contain group-hover:scale-105 transition duration-500" />
        <div className="p-6 text-center font-semibold">
          Digital Standee I-Shape-55 Inch
        </div>
      </Link>
      


    </div>
  </div>
</section>
      {/* ================= APPLICATIONS ================= */}
      <section className="bg-white py-24 px-6">
        <div className="max-w-7xl mx-auto">

          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-blue-700 mb-4">
              Applications
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Digital standees are perfect for dynamic communication and brand promotion.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10">

            {/* Retail */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="overflow-hidden">
                <img
                  src={retailImg}
                  alt="Retail Stores"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center ">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Retail Stores
                </h3>
                <p className="text-gray-600 text-sm">
                  Promote offers and enhance customer engagement inside retail environments.
                </p>
              </div>
            </div>

            {/* Malls */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="overflow-hidden">
                <img
                  src={mallImg}
                  alt="Shopping Malls"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Shopping Malls
                </h3>
                <p className="text-gray-600 text-sm">
                  Eye-catching promotional displays in high-traffic areas.
                </p>
              </div>
            </div>

            {/* Events */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="overflow-hidden">
                <img
                  src={eventImg}
                  alt="Events & Exhibitions"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Events & Exhibitions
                </h3>
                <p className="text-gray-600 text-sm">
                  Showcase products and information dynamically at trade shows and exhibitions.
                </p>
              </div>
            </div>

          </div>

        </div>
                      {/* FOOTER TAGLINE */}
        <div className="mt-20 text-center">
          <p className="text-lg font-semibold text-gray-800">
            <span className="text-blue-600 font-semibold">Beneicon</span> — Trust. Technology. Impact.
          </p>
        </div>
      </section>

    </>
  );
};

export default DigitalStandee;
